module.exports = __webpack_public_path__ + "static/Indri-cdd00374b19b65a49b5522eea2e653c4.jpg";